module.exports = __webpack_public_path__ + "f5fac27170e7059cf53937a2eec2a089.svg";